import { render, staticRenderFns } from "./Folios.vue?vue&type=template&id=6e7670d0&"
import script from "./Folios.vue?vue&type=script&lang=js&"
export * from "./Folios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports